import Component from 'flarum/common/Component';
export default class HomeEffects extends Component {
  root = null;
  motion = true;
  oncreate() {
    this.root = document.querySelector('.NtHome');
    this.motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!this.root || !this.motion) return;
    this.root.addEventListener('pointermove', this.onPointerMove, {
      passive: true
    });
    window.addEventListener('scroll', this.onScroll, {
      passive: true
    });
    this.onScroll();
  }
  onremove() {
    if (this.root) this.root.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('scroll', this.onScroll);
  }
  onPointerMove = event => {
    if (!this.root || event.pointerType === 'touch') return;
    const rect = this.root.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, (event.clientX - rect.left) / Math.max(1, rect.width) * 100));
    const y = Math.max(0, Math.min(100, (event.clientY - rect.top) / Math.max(1, rect.height) * 100));
    this.root.style.setProperty('--nt-pointer-x', `${x}%`);
    this.root.style.setProperty('--nt-pointer-y', `${y}%`);
  };
  onScroll = () => {
    if (!this.root) return;
    const value = Math.max(-18, Math.min(18, window.scrollY * 0.018));
    this.root.style.setProperty('--nt-hero-shift', `${value}px`);
  };
  view() {
    return null;
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/HomeEffects', HomeEffects);